const $ = jQuery;

class ReturningUserForm {
	constructor ($root) {
		this.$root = $root;

		this.setValues();
		this.handleButtonClick();
		this.handleNotYouClicked();

		setTimeout(() => {
			this.hideLoading();
			this.showContent();
		}, 1300);
		
	}

	getContent () {
		return this.$root.find("[data-component=returning-user-form-content]");
	}

	showContent() {
		this.getContent().css("display", "");
	}

	getLoading () {
		return this.$root.find("[data-component=returning-user-form-loading]");
	}

	hideLoading () {
		this.getLoading().css("display", "none");
	}

	getButton () {
		return this.$root.find("button");
	}

	getWelcomeBackName () {
		return this.$root.find("[data-component=returning-user-welcome-back-name]");
	}

	setWelcomeBackNameValue (value) {
		this.getWelcomeBackName().text(value);
	}

	getWelcomeBackEmail () {
		return this.$root.find(
			"[data-component=returning-user-welcome-back-email]"
		);
	}

	setWelcomeBackEmailValue (value) {
		this.getWelcomeBackEmail().text(value);
	}

	setValues () {
		const gateData = new GateData();
		const data = gateData.get();

		if (!data) {
			return;
		}

		this.setWelcomeBackNameValue(data.FirstName);
		this.setWelcomeBackEmailValue(data.Email);
	}

	handleButtonClick () {
		this.getButton().on("click", e => {
			e.preventDefault();
			this.submit();
		});
	}

	getNotYouButton () {
		return this.$root.find("[data-component=returning-user-not-you-button]");
	}

	handleNotYouClicked () {
		this.getNotYouButton().on("click", e => {
			e.preventDefault();
			const event = new ReturningUserNotYouClickedEvent();
			event.trigger();
		});
	}

	getMarketoFieldsForm () {
		return this.$root.find("[data-component=returning-user-marketo-fields]");
	}

	getMarketoFieldsData () {
		return this.getMarketoFieldsForm().serializeObject();
	}

	submit () {
		const gateData = new GateData();
		
		let data = gateData.get();
		const marketoData = this.getMarketoFieldsData();
		data = Object.assign(data, marketoData);

		window.marketoSubmit(data).then(() => {
			const event = new GateFormSubmittedEvent(data);
			event.trigger();
		});
	}
}

$(document).ready(() => {
	$('[data-component=returning-user-form]').each((i, e) => {
		new ReturningUserForm($(e));
	});
});
